/**
 * Paths das rotas da aplicação (uso em <Route path="..."> e navigate()).
 * Centralizados para evitar strings duplicadas e facilitar mudanças.
 */
export const ROUTES = {
    DASHBOARD: '/dashboard',
    ENTREGAS: '/entregas',
    ENTREGA_NOVA: '/entregas/nova',
    ROTAS: '/rotas',
    ROTAS_NOVA: '/rotas/nova',
    ROTEIROS: '/roteiros',
    ROTEIROS_PONTO: (roteiroId, pontoId) => `/roteiros/${roteiroId}/pontos/${pontoId}`,
    ROTEIROS_PONTO_STATUS: (roteiroId, pontoId) => `/roteiros/${roteiroId}/pontos/${pontoId}/status`,
    COLABORADORES: '/colaboradores',
    VEICULOS: '/veiculos',
    RESPONSAVEIS_RECEBIMENTO: '/responsaveis-recebimento',
    RELATORIOS: '/relatorios',
    FATURAS: '/faturas',
    FATURAS_NOVA: '/faturas/nova',
    FATURAS_DETALHE: (id) => `/faturas/${id}`,
    CLIENTES: '/clientes',
    PERFIL: '/perfil',
    CONFIGURACOES: '/configuracoes',
};

/** Rotas da jornada do motorista em que o menu lateral fica oculto. */
export function isDriverHiddenSidebarRoute(pathname) {
    return pathname === ROUTES.ROTEIROS || pathname.startsWith(`${ROUTES.ROTEIROS}/`);
}

/**
 * Chave do <Outlet> do layout principal.
 * Mantém a mesma instância ao navegar entre pontos do mesmo roteiro (evita refetch).
 */
export function getLayoutOutletKey(pathname) {
    const roteiroMatch = pathname.match(/^\/roteiros\/([^/]+)(?:\/|$)/);
    if (roteiroMatch) {
        return `${ROUTES.ROTEIROS}/${roteiroMatch[1]}`;
    }
    return pathname;
}
